import React from 'react'

export const AppointmentsSkeletonLoader: React.FC = () => {
  return (
    <div className="space-y-4">
      {/* First skeleton appointment card */}
      <div className="flex items-stretch border border-app-grey-30 shadow-sm rounded-lg animate-pulse">
        {/* Left side - Calendar icon and content */}
        <div className="flex items-center gap-4 p-4 flex-grow bg-white rounded-l-lg">
          {/* Calendar icon skeleton (square) */}
          <div className="w-16 h-16 bg-app-grey-20 rounded-xl"></div>
          {/* Text content skeleton */}
          <div className="space-y-2 flex-grow">
            {/* Title skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-3/4"></div>
            {/* Time skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-1/2"></div>
            {/* Business name skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-2/3"></div>
          </div>
        </div>
        {/* Right side - View button skeleton (vertical rectangle) */}
        <div className="w-[20%] bg-app-grey-20 rounded-r-lg"></div>
      </div>

      {/* Second skeleton appointment card */}
      <div className="flex items-stretch border border-app-grey-30 shadow-sm rounded-lg animate-pulse">
        {/* Left side - Calendar icon and content */}
        <div className="flex items-center gap-4 p-4 flex-grow bg-white rounded-l-lg">
          {/* Calendar icon skeleton (square) */}
          <div className="w-16 h-16 bg-app-grey-20 rounded-xl"></div>
          {/* Text content skeleton */}
          <div className="space-y-2 flex-grow">
            {/* Title skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-3/4"></div>
            {/* Time skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-1/2"></div>
            {/* Business name skeleton */}
            <div className="h-4 bg-app-grey-20 rounded w-2/3"></div>
          </div>
        </div>
        {/* Right side - View button skeleton (vertical rectangle) */}
        <div className="w-[20%] bg-app-grey-20 rounded-r-lg"></div>
      </div>
    </div>
  )
}
